<template>
  <div class="dialog-mask login-dialog" :class="{ open: isOpen }">
    <div class="dialog-content">
      <div class="dialog-header">{{ 'ChangeEmailTitle' | lang }}</div>
      <div class="dialog-body">
        <div>{{ 'YourCurrentEmailIs' | lang(null, { email: oldEmail }) }}</div>
        <div class="floating-label">
          <input v-model="newEmail" placeholder=" " type="text" :class="{ invalid: invalidEmail }" />
          <label>Email</label>
        </div>
        <ul id="password-errors">
          <li class="text-red" v-if="invalidEmail"><i class="fa fa-fw fa-exclamation-triangle"></i>&nbsp;{{ 'EmailNotValid' | lang }}</li>
          <li class="text-green" v-else><i class="fa fa-fw fa-check"></i>&nbsp;{{ 'EmailValid' | lang }}</li>
        </ul>
        <br />
        <div>{{ 'CompileEmailInstructions' | lang }}</div>
      </div>
      <div class="dialog-footer">
        <button @click="sweetClose(newEmail)" :disabled="invalidEmail">{{ 'Confirm' | lang }}</button>
        <button @click="sweetClose(null)">{{ 'Close' | lang }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'

export default {
  name: 'ChangeEmailAddressDialog',
  mixins: [ dialogMixin ],
  computed: {
    invalidEmail () {
      return this.isSameEmail || !this.checkEmailValidity(this.newEmail)
    },
    isSameEmail () {
      return this.newEmail === this.oldEmail
    },
    oldEmail () {
      return this.user.Email
    }
  },
  data () {
    return {
      newEmail: null
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';

.writing-dialog {
  .fa-check {
    color: var(--green);
  }

  .fa-close {
    color: var(--red);
  }
}

</style>
